import axios from "axios";
import env from "config/env";

import { getIsUserLoggedIn, getAuthToken } from "utils/auth";
import Cookies from "universal-cookie";

const FIELDS_SEPERATOR = ",";

var cookie = new Cookies();
const getLocale = cookie.get("localization");

export const getAuthHeader = () => {
  if (getIsUserLoggedIn()) {
    return {
      Authorization: getAuthToken(),
      locale: getLocale ? getLocale : "en-US",
    };
  }
  return {};
};

export const getJWTToken = () => {
  return getAuthToken();
};

const api = axios.create({
  baseURL: env.REACT_APP_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
    ...getAuthHeader(),
  },
  timeout: 300000,
});

const apiErrorHandler = (e) => {
  if (e.response && e.response.data) {
    if (e.response.data.code) {
      throw e.response.data;
    } else if (e.response.data.message) {
      if (
        e.response.data.message !==
        "User has no permission to access GET Single User!"
      ) {
        throw new Error(e.response.data.message);
      }
    } else {
      throw new Error(e.response.data);
    }
  } else if (e.message) {
    throw e;
  } else {
    throw new Error(
      "Unexpected error occured when calling api. Please contact admin."
    );
  }
};

const constructAndMutateOptions = (params) => {
  // fields
  if (!!params && !!params.fields) {
    params._fields = params.fields;
    delete params.fields;
  }
};

const mutateParamsArrayToString = (params) => {
  if (!!params) {
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        const valueInString = value.join(FIELDS_SEPERATOR);
        params[key] = valueInString;
      }
    });
  }
};

export const updateApiHeaders = () => {
  api.defaults.headers = {
    "Content-Type": "application/json",
    ...getAuthHeader(),
  };
};

api.interceptors.request.use((req) => {
  constructAndMutateOptions(req.params);
  mutateParamsArrayToString(req.params);
  return req;
});
api.interceptors.response.use((res) => res.data, apiErrorHandler);

export default api;
